const state = {
    config: {
        preferences: {
            filters: {
                resolution: {
                    assignedTo: undefined
                }
            }
        }
    }
}

const getters = {
    getPreferences: state => state.config.preferences
}

const actions = {
    setResolutionFilter({commit}, filter){
        commit('setResolutionFilter', filter)
    }
}

const mutations = {
    setResolutionFilter: (state, filter) => (state.config.preferences.filters.resolution = filter)
}

export default {
    state,
    getters,
    actions,
    mutations
}